import{Component}from'@theme/component';
import{ThemeEvents,VariantUpdateEvent}from'@theme/events';
class ProductSkuComponent extends Component{
requiredRefs=['skuContainer','sku'];
connectedCallback(){super.connectedCallback();const t=this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');if(!t)return;t.addEventListener(ThemeEvents.variantUpdate,this.updateSku);}
disconnectedCallback(){super.disconnectedCallback();const t=this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');if(!t)return;t.removeEventListener(ThemeEvents.variantUpdate,this.updateSku);}
updateSku=(e)=>{
if(e.detail.data.newProduct)this.dataset.productId=e.detail.data.newProduct.id;
if(e.target instanceof HTMLElement&&e.target.dataset.productId!==this.dataset.productId)return;
if(e.detail.resource){const s=e.detail.resource.sku||'';if(s){this.style.display='block';this.refs.sku.textContent=s;}else{this.style.display='none';this.refs.sku.textContent='';}}
};
}
if(!customElements.get('product-sku-component'))customElements.define('product-sku-component',ProductSkuComponent);